import Bottom from "../../components/Layouts/Bottom";
import MyProfile from "../../components/Profile/MyProfile";
import React from "react";

const MyProfilePage = () => {
  return (
    <>
      <div className="full-sec"><div className="right-sec">
          <MyProfile />
        </div>
      </div>
      <Bottom />
    </>
  );
};

export default MyProfilePage;
